<template>
	<div class="head" v-if="showHead">
		<div class="back" @click="textClick">
			<van-icon name="arrow-left" />返回
		</div>
		<div class="all_function">
			{{ title }}
		</div>
		<div class="space"></div>
	</div>
</template>
<script>
import axios from 'axios'
export default {
	name: 'headbar',
	data() {
		return {
			showHead: false,
			device: '',
		}
	},
	props: {
		title: {
			type: String,
		},
		index: {
			type: String,
		},
	},
	created() {
		this.device = localStorage.getItem('device')
	},
	methods: {
		async textClick() {
			let res = await axios.post(
				'http://192.168.68.101:8089/api/reguser',
				{ username: 'abc333', password: '565656' }
			)
			console.log(res)
		},

		goBack() {
			if (this.index == 0) {
				this.judge('0')
			} else if (this.index == 1) {
				this.$router.go(-1)
			}
		},
		judge(type) {
			let nowDevice = localStorage.getItem('device')
			if (nowDevice == 'ios') {
				window.webkit.messageHandlers.jsToOcWithPrams.postMessage({
					jump_type: type,
					jump_url: '',
				})
			} else if (nowDevice == 'android' || nowDevice == 'ard' || nowDevice === "pad") {
				window.android.jsCallAndroidArgs(
					`{jump_type: ${type}, jump_url: ''}`
				)
			}
		},
	},
}
</script>
<style lang="scss">
.head {
	height: 4rem;
	background-color: #dc0d1a;
	display: flex;
	padding: 12px;
	align-items: center;
	justify-content: space-between;
	box-sizing: border-box;
	.all_function {
		color: white;
		font-weight: bold;
		font-size: 34rpx;
	}
	.back {
		color: white;
		font-size: 13px;
	}
	.space {
		width: 50px;
	}
}
</style>
